import { createRouter, createWebHistory, START_LOCATION } from "vue-router"

import LoginView from "../views/LoginView.vue"
import MypageView from "../views/MypageView.vue"

// Read the prerendered scroll position before createApp replaces its DOM.
export const initialPageWasScrolled =
  typeof document !== "undefined" &&
  (window.scrollY > 0 ||
    (document.scrollingElement?.scrollTop || 0) > 0 ||
    (document.getElementById("global-container")?.scrollTop || 0) > 0)

const routes = [
  {
    path: "/",
    name: "map",
    component: () => import("../views/MapView.vue"),
  },
  {
    path: "/FishLogList",
    name: "FishLogList",
    component: () => import("../components/FishLogList.vue"),
  },
  {
    path: "/FishLog",
    name: "FishLog",
    component: () => import("../views/FishLogView.vue"),
  },
  {
    path: "/Contactfinish",
    name: "Contactfinish",
    component: () => import("../views/ContactFinish.vue"),
  },
  {
    path: "/PostView",
    name: "PostView",
    component: () => import("../views/prePostView.vue"),
  },
  {
    path: "/Setting",
    name: "Setting",
    component: () => import("../views/preSettingView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/preLoginView.vue"),
  },
  {
    path: "/Contact",
    name: "Contact",
    component: () => import("../views/PreContactView.vue"),
  },
  {
    path: "/mypage",
    name: "My Page",
    component: () => import("../views/preMypageView.vue"),
  },
  {
    path: "/markView",
    name: "MarkView",
    component: () => import("../views/MarkView.vue"),
  },
  {
    path: "/policy",
    name: "Policy",
    component: () => import("../views/PolicyView.vue"),
  },
  {
    path: "/tos",
    name: "TOS",
    component: () => import("../views/TermsOfService.vue"),
  },
  {
    path: "/goods",
    name: "Goods",
    component: () => import("../views/GoodsView.vue"),
  },
  {
    path: "/shop",
    name: "Shop",
    component: () => import("../views/ShopView.vue"),
  },
  {
    path: "/shop/:slug",
    name: "ShopDetail",
    component: () => import("../views/ShopDetailView.vue"),
  },
  // --- 追加 ---
  {
    path: "/spots",
    name: "Spots",
    component: () => import("../views/SpotsView.vue"),
  },
  {
    path: "/spots/:slug",
    name: "SpotDetail",
    component: () => import("../views/SpotDetailView.vue"),
  },
  {
    path: "/fish",
    name: "FishList",
    component: () => import("../views/FishListView.vue"),
  },
  {
    path: "/fish/:slug",
    name: "FishDetail",
    component: () => import("../views/FishDetailView.vue"),
  },
  {
    path: "/qr",
    name: "QrLanding",
    component: () => import("../views/QrLandingView.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

let initialPageNavigation = true

// START_LOCATION also identifies a reload with an existing browser history.
router.afterEach((to, from, failure) => {
  if (!failure) initialPageNavigation = from === START_LOCATION
})

export function isInitialPageNavigation() {
  return initialPageNavigation
}

export default router
